import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatBottomSheet} from '@angular/material';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {ConsentsFormService} from '../../../../services/consents-form.service';
import {HeaderService} from '../../../../services/header.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {SortConsentBottomSheetComponent} from '../sort-consent-bottom-sheet/sort-consent-bottom-sheet.component';

@Component({
    selector: 'app-parent-consents',
    templateUrl: './parent-consents.component.html',
    styleUrls: ['./parent-consents.component.scss']
})
export class ParentConsentsComponent implements OnInit, OnDestroy {
    isLoading: boolean;
    consents: any = [];
    displayConsents: any = [];
    listHeight;
    subscription: Subscription;

    constructor(private headerService: HeaderService,
                public router: Router,
                private bottomSheet: MatBottomSheet,
                private consentsFormService: ConsentsFormService,
                public toastService: ToastMessagesService) {
        this.isLoading = true;
        this.listHeight = window.innerHeight - 100;
    }

    async ngOnInit(): Promise<void> {
        try {
            this.initSubscriptions();
            await this.initComponent();
        } catch (e) {
            this.toastService.toastErrorMessage(e.message);
        } finally {
            this.isLoading = false;
        }
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    async initComponent() {
        this.headerService.setHeaderTitle(`Προσωπικές δηλώσεις`);
        await this.initPersonalConsents();
    }

    async initPersonalConsents() {
        this.consents = await this.consentsFormService.getPersonalForms();
        this.displayConsents = this.consents.slice();
    }

    initSubscriptions() {
        this.subscription = this.headerService.observerShowBottomSheet().subscribe(state => {
            if (state) {
                this.openBottomSheet();
            }
        });
    }

    openBottomSheet() {
        const bottomSheet = this.bottomSheet.open(SortConsentBottomSheetComponent, {
            data: {
                items: [
                    {
                        key: 'published_at',
                        label: 'Ημερομηνία δημοσίευσης',
                        type: 'date',
                        order: {key: 'asc', label: 'Αύξουσα σειρά'}
                    },
                    {
                        key: 'published_at',
                        label: 'Ημερομηνία δημοσίευσης',
                        type: 'date',
                        order: {key: 'desc', label: 'Φθίνουσα σειρά'}
                    },
                    {
                        key: 'title',
                        label: 'Τίτλος δημοσίευσης',
                        type: 'string',
                        order: {key: 'asc', label: 'Αύξουσα σειρά'}

                    },
                    {
                        key: 'title',
                        label: 'Τίτλος δημοσίευσης',
                        type: 'string',
                        order: {key: 'desc', label: 'Φθίνουσα σειρά'}

                    }
                ]
            }
        });

        bottomSheet.afterDismissed().subscribe(response => {
            if (response) {
                this.sortMessages(response.key, response.type, response.order.key);
                this.headerService.setShowBottomSheet(false);
            }
        });
    }

    sortMessages(sortBy: string = null, type: string = null, direction: string = null) {
        try {
            this.isLoading = true;
            this.displayConsents = [];
            if (direction) {
                if (direction === 'asc') {
                    if (type === 'date') {
                        this.consents.sort((a, b) => (this.stringToDate(a[sortBy]) > this.stringToDate(b[sortBy])) ? 1 : (this.stringToDate(b[sortBy]) > this.stringToDate(a[sortBy])) ? -1 : 0);
                    } else {
                        this.consents.sort((a, b) => (a[sortBy] > b[sortBy]) ? 1 : (b[sortBy] > a[sortBy]) ? -1 : 0);
                    }
                } else {
                    if (type === 'date') {
                        this.consents.sort((a, b) => (this.stringToDate(a[sortBy]) < this.stringToDate(b[sortBy])) ? 1 : (this.stringToDate(b[sortBy]) < this.stringToDate(a[sortBy])) ? -1 : 0);
                    } else {
                        this.consents.sort((a, b) => (a[sortBy] < b[sortBy]) ? 1 : (b[sortBy] < a[sortBy]) ? -1 : 0);
                    }
                }
            }

            this.displayConsents = this.consents.slice();
        } catch (e) {
            console.log(e);
        } finally {
            this.isLoading = false;
        }
    }

    private stringToDate(dateString: string): Date {
        try {
            const tempString = dateString.split('-');
            const tempTime = tempString[2].split(' ');
            const year = tempTime[0];
            const month = tempString[1];
            const day = tempString[0];
            const time = tempTime[1];

            const formattedDateString = `${year}-${month}-${day} ${time}`;
            return new Date(formattedDateString);
        } catch (e) {
            return null;
        }
    }

    async showPersonalForm(form: any) {
        const inputConfig = {
            edit: true,
            childId: form.child_id,
            mode: false,
            parentId: form.notification_to_parent,
            unique_id: form.uniqueId,
            version: 'latest',
            id: form.id,
        };
        console.log(inputConfig);
        await this.router.navigate(['/home/parentRequestForm'], {queryParams: inputConfig});
    }
}
